
// Vue reactivity
import { computed, watch } from 'vue';

// icons
import { informationCircleOutline, close, add, checkmark, arrowBack, } from 'ionicons/icons';

// components
import { IonPage, IonGrid, IonHeader, IonFooter, IonToolbar, IonTitle, IonContent, IonSpinner,
        IonButtons, IonButton, IonIcon,
        onIonViewDidEnter,
        onIonViewWillLeave, } from '@ionic/vue';
import ProfessionDetails from '@/components/pss/ProfessionDetails.vue';

// API services
import { useStore } from '@/store';
import { useI18n } from 'vue-i18n';
import { utils } from '@/composables/utils';
import { useRoute } from 'vue-router';

// types
import { Profession } from '@/types';
import ABSService from '@/services/ABSService';
import UserService from '@/services/UserService';

export default {
  name: 'ProfessionPage',
  components: { IonPage, IonGrid, IonHeader, IonFooter, IonToolbar, IonTitle, IonContent, IonSpinner,
                IonButtons, IonButton, IonIcon,
                ProfessionDetails, },
  setup() {
    const store = useStore();
    const { t } = useI18n();
    const route = useRoute();
    const { name: currProfessionName } = route.params;

    // 1. declare state variables (ref to make them reactive)
    const loading = computed(() => store.state.loadingPortalData);
    const profession = computed<Profession>(() => store.getters.getProfessionByName(currProfessionName));
    const user = computed(() => store.state.user);

    // methods or filters
    const { formatDate } = utils();

    let accessTime, duration = 0, counterInterval;
    onIonViewDidEnter(() => {
      // Initial Access
      ABSService.insertPageAccessRecord(`ProfessionPage | ${currProfessionName}`, new Date(), null);

      // Record Access & Leave Time
      accessTime = new Date();
      counterInterval = setInterval(() => (duration++), 1000);
    });
    onIonViewWillLeave(() => {
      if (accessTime && duration >= 3) {
        const { id, name } = profession.value || {};
        ABSService.insertPageAccessRecord(`ProfessionPage | ${name} | ${id}`, accessTime, new Date(accessTime.getTime() + duration*1000));
        accessTime = undefined;
        duration = 0; // reset;
        clearInterval(counterInterval);
      }
    });

    watch(user, () => {
      UserService.addUserBrowsedProfession(profession.value.id); // add to browse history
      store.commit('addUserBrowsedProfession', profession.value.id);
    });
    
    // 3. return variables & methods to be used in template HTML
    return {
      // icons
      informationCircleOutline, close, add, checkmark, arrowBack,

      // variables
      currProfessionName, loading, profession,
      user,

      // methods
      t, formatDate,
      addToUserTargetProfession: (profession: any) => {
        const { lastSelectedProfessions } = user.value;

        // Add to target profession list
        const newSelectedProfessions = [profession, ...(lastSelectedProfessions || [])];
        const newStep1OrderedProfessionIds = newSelectedProfessions.map(p => p.id).join(" , ");

        // Update DB
        ABSService.saveUserChoices({
          step1OrderedProfessionIds: newStep1OrderedProfessionIds
        });

        // Update Store
        store.commit('updateUser', {
          step1OrderedProfessionIds: newStep1OrderedProfessionIds,
          lastSelectedProfessions: newSelectedProfessions.slice(),
        });
      }
    }
  },
}
